import { HorizontalBar } from 'vue-chartjs';

export default {
  extends: HorizontalBar,
  props: ['datasBarChart'],
  data() {
    return {
      xlabel: 'click',
    };
  },
  mounted() {
    this.gradient = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 500, 0);
    this.gradient2 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 500, 0);
    this.gradient3 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 500, 0);
    this.gradient4 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 500, 0);
    this.gradient5 = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 500, 0);

    this.gradient.addColorStop(1, 'rgba(4, 58, 70, 0.9)');
    this.gradient.addColorStop(0.5, 'rgba(4, 58, 70, 0.25)');
    this.gradient.addColorStop(0, 'rgba(4, 58, 70, 0)');

    this.gradient2.addColorStop(1, 'rgba(153, 55, 26, 0.9)');
    this.gradient2.addColorStop(0.5, 'rgba(153, 55, 26, 0.25)');
    this.gradient2.addColorStop(0, 'rgba(153, 55, 26, 0)');

    this.gradient3.addColorStop(1, 'rgba(255, 196, 30, 0.5)');
    this.gradient3.addColorStop(0.5, 'rgba(255, 196, 30, 0.25)');
    this.gradient3.addColorStop(0, 'rgba(255, 196, 30, 0)');

    this.gradient4.addColorStop(1, 'rgba(31, 85, 97, 0.9)');
    this.gradient4.addColorStop(0.5, 'rgba(31, 85, 97, 0.25)');
    this.gradient4.addColorStop(0, 'rgba(31, 85, 97, 0)');

    this.gradient5.addColorStop(1, 'rgba(210, 163, 73, 0.9)');
    this.gradient5.addColorStop(0.5, 'rgba(210, 163, 73, 0.25)');
    this.gradient5.addColorStop(0, 'rgba(210, 163, 73, 0)');

    this.renderChart(
      {
        labels: this.getLabels(this.datasBarChart),
        datasets: [
          {
            label: 'Moyenne du temps passé (en minute)',
            data: this.getViews(this.datasBarChart),
            backgroundColor: [
              this.gradient,
              this.gradient2,
              this.gradient3,
              this.gradient4,
              this.gradient3,
              this.gradient2,
              this.gradient1,
              this.gradient,
            ],
          },
        ],
      },
      {
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: this.xlabel,
              },
              gridLines: {
                display: false,
              },
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    );
  },
  methods: {
    getLabels(periode) {
      const labels = [];
      for (let i = 0; i < periode.length; i++) {
        if (periode[i][1] / 60) {
          labels.push(periode[i][0].slice(0, 20));
        }
      }
      return labels;
    },
    getViews(periode) {
      const datas = [];
      for (let i = 0; i < periode.length; i++) {
        const temp = periode[i];
        datas.push(temp.toString());
      }
      return datas;
    },
  },
};
